/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { PlanName } from '../../../ts/plan';

/**
 *
 * Returns true if the specified plan is functionally equivalent to the
 * Enterprise plan (which includes the Enterprise and Enterprise with
 * Data Isolation plans)
 *
 * @param plan The plan we want to verify
 * @return True if the plan is functionally Enterprise
 */
export const isEnterprisePlan = (plan: PlanName): boolean =>
  plan === PlanName.ENTERPRISE || plan === PlanName.ENTERPRISE_DATA_ISOLATION;
